import React from 'react';
import { useLocation } from 'react-router-dom';

function useQuery() {
  const location = useLocation();

  return React.useMemo(() => new URLSearchParams(location?.search), [location?.search]);
}

export default useQuery;
